import React from 'react';
import { Box, Typography } from '@mui/material';
import { brand } from '../theme';

export default function SectionHeading({ eyebrow, title, subtitle, align = 'center', maxWidth = 720 }) {
  return (
    <Box sx={{ textAlign: align, maxWidth, mx: align === 'center' ? 'auto' : 0, mb: { xs: 5, md: 7 } }}>
      {eyebrow && (
        <Typography
          variant="overline"
          sx={{
            color: brand.blue,
            fontWeight: 700,
            letterSpacing: '0.18em',
            display: 'inline-block',
            mb: 1.5,
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography variant="h2" sx={{ fontSize: { xs: '2rem', md: '2.75rem' }, mb: subtitle ? 2 : 0 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" sx={{ color: brand.slate, fontSize: { xs: '1.05rem', md: '1.15rem' } }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
